module.exports = __webpack_public_path__ + "static/blog-03ef524a37ac5ea42ec9c818797bae25.png";